import _ from 'lodash';
import Util from '@/store/_SPBoxUtil';

const state = {
	selected: [],
	isSuccess: false,
};

const mutations = {
	add(state, items) {
		Util.add(state, items, 'goods', 'idProduct');
	},
	set(state, data) {
		state.selected = _.sortBy(
			_.each(data, item => {
				item.checked = false;
			}),
			['priority']
		);
	},
	remove(state, codes) {
		_.each(codes, code => {
			const index = _.findIndex(state.selected, { idProduct: code });

			state.selected.splice(index, 1);
		});
	},
	clear(state) {
		state.selected = [];
	},
	toggle(state, to) {
		_.each(state.selected, item => {
			item.checked = to;
		});
	},
	up(state, target) {
		Util.move(state, 'goods', target, 'up');
	},
	down(state, target) {
		Util.move(state, 'goods', target, 'down');
	},
	bottom(state, target) {
		Util.end(state, 'goods', target, 'bottom');
	},
	top(state, target) {
		Util.end(state, 'goods', target, 'top');
	},
};

const getters = {
	getGoods(state) {
		return _.sortBy(state.selected, ['priority']);
	},
};

const actions = {};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
